// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3iAkg","header":"PatientQuestionnaire_header__2aAxc","info":"PatientQuestionnaire_info__1FHM9"};